// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc5cf75d","239":"e2b67acc","453":"edb192ee","732":"6cf9d7ab"}[chunkId] + ".chunk.js";
};